var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.6901 27.06C40.8617 27.06 40.1901 26.3885 40.1901 25.56V6.56C40.1901 2.93704 37.2531 0 33.6301 0C30.0071 0 27.0701 2.93704 27.0701 6.56V25.56C27.0701 26.3885 26.3986 27.06 25.5701 27.06H6.57011C2.94164 27.06 0.00012207 30.0015 0.00012207 33.63C0.00012207 37.2585 2.94164 40.2 6.57011 40.2H25.5701C26.3986 40.2 27.0701 40.8715 27.0701 41.7V60.7C27.0701 64.323 30.0071 67.26 33.6301 67.26C37.2531 67.26 40.1901 64.323 40.1901 60.7V41.7C40.1901 40.8715 40.8617 40.2 41.6901 40.2H60.6901C64.3147 40.1945 67.2501 37.2546 67.2501 33.63C67.2501 30.0054 64.3147 27.0655 60.6901 27.06H41.6901V27.06Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.7e0431693eed6c3a3d84d4a5e1c54516.svg";
export { ForwardRef as ReactComponent };